import { render, staticRenderFns } from "./AdGroupsModal.vue?vue&type=template&id=564bfb28&"
import script from "./AdGroupsModal.vue?vue&type=script&lang=js&"
export * from "./AdGroupsModal.vue?vue&type=script&lang=js&"
import style0 from "./AdGroupsModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VCol,VContainer,VDataTable,VDialog,VIcon,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686294843/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('564bfb28')) {
      api.createRecord('564bfb28', component.options)
    } else {
      api.reload('564bfb28', component.options)
    }
    module.hot.accept("./AdGroupsModal.vue?vue&type=template&id=564bfb28&", function () {
      api.rerender('564bfb28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contracts/AdGroupsModal.vue"
export default component.exports